import { StyledIconButton } from "./styles";

interface CustomIconButtonProps {
  ariaLabel: string;
  icon: string;
  handleClick: () => void;
  className?: string;
}

const CustomIconButton = ({
  ariaLabel,
  icon,
  handleClick,
  className,
}: CustomIconButtonProps) => {
  return (
    <StyledIconButton
      onClick={handleClick}
      size="large"
      edge="start"
      className={className}
      aria-label={ariaLabel}
    >
      <img src={icon} alt="" />
    </StyledIconButton>
  );
};

CustomIconButton.defaultProps = {
  className: "",
};

export default CustomIconButton;
